module.exports = __webpack_public_path__ + "static/img/2s-info-b3.b03463c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-info-b3.jpg
// module id = I3h8
// module chunks = 0